<template>
  <div class="gauge-chart">
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
      <!-- Background Circle -->
      <circle
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        stroke="#eee"
        :stroke-width="strokeWidth"
      />

      <!-- Foreground Arc (Progress) -->
      <circle
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        :stroke="gaugeColor"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        :stroke-dasharray="dashArray"
        :stroke-dashoffset="dashOffset"
        :transform="`rotate(-90, ${center}, ${center})`"
      />

      <!-- Percentage Text -->
      <text
        :x="center"
        :y="center"
        text-anchor="middle"
        alignment-baseline="central"
        :font-size="size * 0.16"
        font-weight="bold"
        fill="#303133"
      >
        {{ value }}%
      </text>

      <!-- Label Text -->
      <text
        :x="center"
        :y="center + size * 0.2"
        text-anchor="middle"
        :font-size="size * 0.1"
        fill="#666"
      >
        {{ label }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'GaugeChart',
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 80
    }
  },
  computed: {
    center() {
      return this.size / 2;
    },
    strokeWidth() {
      return this.size * 0.1;
    },
    radius() {
      return this.center - this.strokeWidth / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dashArray() {
      return this.circumference.toFixed(2);
    },
    dashOffset() {
      const offset = this.circumference * (1 - this.value / 100);
      return offset.toFixed(2);
    },
    gaugeColor() {
      if (this.value <= 60) return '#67C23A'; // green
      if (this.value <= 80) return '#E6A23C'; // yellow
      return '#F56C6C'; // red
    }
  }
};
</script>

<style scoped>
.gauge-chart {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
